// extracted by mini-css-extract-plugin
module.exports = {"homeWrapper":"Home_homeWrapper__1728-","timerWrapper":"Home_timerWrapper__1QGVK","buttons":"Home_buttons__2nvmD"};